import forEach from 'dcode/functions/forEach'
import getPostLink from '@/functions/getPostLink'

export default function getPopular (basic) {
  const popular = []

  forEach(basic, item => {
    const list = []

    item.list.forEach(item => {
      if (item.popular) {
        list.push({
          text: item.text,
          value: getPostLink(item)
        })
      }
    })

    if (list.length > 0) {
      popular.push({
        ...item,
        list
      })
    }
  })

  return popular
}
